"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngusCalveDetailSchema = exports.AngusCalveProfileSchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("../misc/token"));
exports.AngusCalveProfileSchema = zod_1.z.object({
    sire_id: zod_1.z.string(),
    sire_group_id: zod_1.z.string(),
    acct_id: zod_1.z.string(),
    birth_year: zod_1.z.number(),
    birth_start: zod_1.z.string(),
    birth_end: zod_1.z.string(),
    lt: zod_1.z.union([zod_1.z.literal("N"), zod_1.z.literal("Y")]),
    eu: zod_1.z.union([zod_1.z.literal("N"), zod_1.z.literal("Y")]),
    rfid: zod_1.z.string(),
    nlis_id: zod_1.z.string(),
    sex: zod_1.z.string(),
    visual_tag: zod_1.z.string(),
    pic: zod_1.z.string(),
    pic_id: zod_1.z.string().optional(),
    mob_name: zod_1.z.string(),
    mobs: zod_1.z.array(zod_1.z.object({
        name: zod_1.z.string(),
        year: zod_1.z.number()
    })),
    recordedIn: zod_1.z.string(),
    angusAuthToken: zod_1.z.string(),
    breederPicAddress: zod_1.z.string(),
    externalIds: TokenMisc.ExternalIdsSchema.optional(),
});
// AngusCalve
exports.AngusCalveDetailSchema = exports.AngusCalveProfileSchema.merge(zod_1.z.object({
    externalIds: TokenMisc.ExternalIdsSchema,
    sire_nlis_id: zod_1.z.string().optional(),
    sire_rfid: zod_1.z.string().optional(),
    unit: zod_1.z.string().optional(),
    weight: zod_1.z.number().optional(),
    date_of_weight: zod_1.z.string().optional(),
    date_of_location: zod_1.z.string().optional(),
    location_lat: zod_1.z.number().optional(),
    location_long: zod_1.z.number().optional(),
}));
